export default __webpack_public_path__ + "static/media/bizCms.486214ca.png";